<template>
	<v-container fluid>
		<v-row justify="center" class="live-body">
			<v-col cols="12" md="8">
				<v-carousel height="100%" show-arrows="hover" hide-delimiters>
					<v-carousel-item>
						<v-img
						src="@/assets/images/banner1.jpg"
						class="carousel-image"
						contain
						></v-img>
					</v-carousel-item>
				</v-carousel>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		name: 'NewsAndEvents',

		data: () => ({
			carouselHeight: "700px", // Default value
		}),

		mounted() {
			this.updateCarouselHeight(); // Set initial height
			window.addEventListener("resize", this.updateCarouselHeight);
		},

		beforeUnmount() {
			window.removeEventListener("resize", this.updateCarouselHeight);
		},

		methods: {
			getDynamicHeight() {
			return window.innerWidth < 600 ? "300px" : "500px"; // Adjust height for mobile
			},
			updateCarouselHeight() {
			this.carouselHeight = this.getDynamicHeight();
			},
		},
	}
</script>

<style scoped>
.index {
	text-align: center;
	margin: 10%;
}

.live-body {
  background-color: rgba(0, 0, 0, 0.5);
  margin-bottom: 5px;
}

</style>
